import * as React from "react"
import { coordinatesToPlace } from "../helpers/geocode"
import { Coord } from "../helpers/map"

export function useReverseGeocode(coords: Coord) {
  const [address, setAddress] = React.useState("")

  const getLocation = React.useCallback(async () => {
    const a = await coordinatesToPlace(coords)
    setAddress(a)
  }, [coords])

  React.useEffect(() => {
    getLocation()
  }, [getLocation])

  return address
}
